import React, { useEffect, useState } from "react";
import { TableColumn } from "../../../components/CommnTable/CustomDataTable";
import { FormField, FundsPaymentInterface } from "../../../types/types";
import { Box, Button, useMediaQuery } from "@mui/material";
import { blue } from "@mui/material/colors";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useGet } from "../../../services/hooks/useGet";
import { DeleteUrl, GetUrl, PatchUrl } from "../../../api/endpointConfig";
import { useLoader } from "../../../Loader/LoaderContext";
import { useFundContext } from "../../../Context/FundManagementContext";
import {
  FundAddPaymentForm,
  FundEditPaymentForm,
} from "../../../types/formTypes";
import { useMutationByMethod } from "../../../services/hooks/useMutationByMethod";
import { ToastService } from "../../../utils/toastService";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { API_URL, API_VERSION } from "../../../config/config";
import axios from "axios";
import { apiClient } from "../../../services/hooks/api";

const usePaymentHistory = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const [offsetValue, setOffsetValue] = useState<number>(0);
  const [limitValue, setLimitValue] = useState<number>(10);
  const { fundDetail } = useFundContext();
  const { showLoader, hideLoader } = useLoader();
  const [queryParams, setQueryParams] = useState<any>({});

  const userData: any = JSON.parse(localStorage.getItem("userData") || "{}");
  const pagination: Record<string, string | number | null> = {
    offset: offsetValue,
    limit: limitValue,
  };
  const [editState, setEditState] = useState<boolean>(false);
  const [editRowData, setEditRowData] = useState<any>([]);

  const {
    data = [],
    isLoading,
    isError,
    refetch,
  } = useGet<any>(`${GetUrl.getFundHistory}/${id}`, {
    params: { ...pagination, ...queryParams },
  });

  const HandlePagination = (e: any) => {
    setLimitValue(e.rows);
    setOffsetValue(e.page + 1);
  };

  useEffect(() => {
    const prefix = searchParams.get("prefix");
    const text = searchParams.get("text");
    setQueryParams((prev: any) => {
      const updated = { ...prev };

      if (text && prefix) {
        updated[prefix] = text;
      } else {
        setQueryParams({});
      }
      return updated;
    });
  }, [searchParams]);

  useEffect(() => {
    if (isLoading && !isError) {
      showLoader();
    } else if (isError) {
      hideLoader();
    } else {
      hideLoader();
    }
  }, [isLoading, isError]);

  const editViewPayment = (row: FundsPaymentInterface) => {
    setEditState(!editState);
    setEditRowData(row);
  };
 
const deleteViewPayment = async (row: FundsPaymentInterface) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this entry from the Fund History? This action is permanent, and the data will not be retrievable in the future."
    );
    if (!confirmDelete) return;
    try {
        const url = `${API_URL}/${API_VERSION}/${DeleteUrl.deleteFundPayment}/${row.id}`;
        const response = await apiClient.delete(url);
        const successMessage = response.message;
        ToastService.success(successMessage);
        refetch();
    } catch (err) {
      console.error("Delete failed", err);
      ToastService.error("Failed to remove document");
    }
};
  const nagivate = useNavigate();
  const today = new Date();
  // Feature date disabling in date picker
  const minDatePrev = new Date(
    today.getFullYear() - 100,
    today.getMonth(),
    today.getDate()
  )
    .toISOString()
    .split("T")[0];

  // Maximum date: today (no future date allowed)
  const maxDatePrev = today.toISOString().split("T")[0];

  const minDate = new Date(today);
  minDate.setDate(today.getDate() + 1);
  const formattedMinDate = minDate.toISOString().split("T")[0]; // YYYY-MM-DD

  // Set maxDate as 10 years from today
  const maxDate = new Date(
    today.getFullYear() + 10,
    today.getMonth(),
    today.getDate()
  )
    .toISOString()
    .split("T")[0];
  const { mutate } = useMutationByMethod<any>(
    "patch",
    `${PatchUrl.patchFund}/${Number(editRowData.id)}`
  );
 
  const fundsFormFields: FormField<FundEditPaymentForm>[] = [
    {
      name: "fund_disburstment_amt",
      text_label: "Funds Disbursed",
      defaultValue: editRowData.Funds_Disbursed ?? "",
      type: "number",
      validate: (val: any) =>
        val.length == 0 && "fund disburstment amt is required ",
      grid: { xs: 12, sm: 6, md: 3, lg: 2 },
    },
    {
      name: "payment_date",
      text_label: "Payment Date",
      defaultValue: editRowData.date_of_payment ?? "",
      type: "date",
      inputProps: {
        min: minDatePrev,
        // max: maxDatePrev,
      },
      validate: (val: any) => val?.length == 0 && "Payment date is required ",
      grid: { xs: 12, sm: 6, md: 3, lg: 3 },
    },
    {
      name: editRowData.transaction_ID
        ? "transaction_ref_no"
        : editRowData.cheque_details
        ? "cheque_details"
        : editRowData.dd_details
        ? "DD_number"
        : "transaction_number",
      options: [
        { label: "Cheque Details", value: "cheque_details" },
        { label: "DD Details", value: "DD_number" },
        { label: "Transaction ID", value: "transaction_ref_no" },
      ],
      text_label: "DD Details/Transaction ID/Cheque Details",
      defaultValue:
        (editRowData.transaction_ID ||
          editRowData.cheque_details ||
          editRowData.dd_details) ??
        "",
      validate: (val: any) => {
        console.log("val", val);
        return val.length == 0 && "Please select any one Option"},
      type: "textWithDropDown",
      grid: { xs: 12, sm: 6, md: 4, lg: 4 },
      dropdownKeyMap: editRowData.transaction_ID
        ? "transaction_ref_no"
        : editRowData.cheque_details
        ? "cheque_details"
        : editRowData.dd_details ? "DD_number" : '',
    },
    {
      name: "purpose",
      text_label: "Purpose",
      defaultValue: editRowData.purpose ?? "",
      options: fundDetail?.purpose,
      type: "select",
      disabled: true,
      validate: (val: any) => val.length == 0 && "purpose is required ",
      grid: { xs: 12, sm: 4, md: 3, lg: 3 },
    },
    {
      name: "installment_paid",
      text_label: "Installment Given",
      defaultValue: editRowData.installment_given ?? "",
      validate: (val: any) =>
        val?.length == 0 && "Installment paid no is required ",
      type: "number",
      grid: { xs: 12, sm: 3, md: 4, lg: 4 },
    },
    {
      name: "next_installment_dt",
      text_label: "Next Installment Date",
      defaultValue: editRowData.next_installment_dt?.split("T")[0] ?? "",
      inputProps: {
        min: minDatePrev,
        // max: maxDate,
      },
      validate: (val: any) =>
        val?.length == 0 && "Next installment date is required ",
      type: "date",
      grid: { xs: 12, sm: 6, md: 4, lg: 4 },
    },
    {
      name: "next_installment_purpose",
      text_label: "Next Installment Purpose",
      defaultValue: editRowData.purpose ?? "",
      options: fundDetail?.purpose,
      type: "select",
      disabled: true,
      grid: { xs: 12, sm: 6, md: 4, lg: 4 },
    },
    {
      name: "next_installment_amt",
      text_label: "Next Installment Amount",
      defaultValue: editRowData.next_installment ?? "",
      validate: (val: any) =>
        val.length == 0 && "Next installment Amount is required ",
      type: "number",
      grid: { xs: 12, sm: 6, md: 4, lg: 4 },
    },
    {
      name: "description",
      text_label: "Description",
      defaultValue: editRowData.description ?? "",
      type: "textArea",
      grid: { xs: 12, sm: 12, md: 12, lg: 12 },
    },
  ];
  const handleOnSubmit = (formData: FundEditPaymentForm) => {
    showLoader();
    mutate(formData, {
      onSuccess: (data: any) => {
        hideLoader();
        ToastService.success("Fund updated successfully");
        // nagivate(`/fund-viewpayment/${Number(id)}`);
        refetch();
        setEditState(false);
      },
      onError: (err: any) => {
        hideLoader();
        console.error("error", err);
        ToastService.error(err);
      },
    });
  };
  const isDesktop = useMediaQuery("(min-width:1025px)");
  const columns: TableColumn<FundsPaymentInterface>[] = [
    {
      field: "Funds_Disbursed",
      header: "Funds Disbursed",
      width: "8rem",
      sortable: true,
      customBody: (row) => <Box sx={{ m: 2 }}>{row.Funds_Disbursed}</Box>,
    },
    {
      field: "date_of_payment",
      header: "Date of Payment",
      sortable: true,
      width: "8rem",
      filterable: true,
    },
    { field: "description", header: "Description", width: "3rem" },
    { field: "purpose", header: "Purpose", width: "8rem", filterable: true },
    {
      field: "dd_details",
      header: "DD Details",
      width: "8rem",
      filterable: true,
    },
    {
      field: "cheque_details",
      header: "Cheque Details",
      width: "8rem",
      filterable: true,
    },
    {
      field: "transaction_ID",
      header: "Transaction ID",
      width: "8rem",
      filterable: true,
    },
    {
      field: "next_installment",
      header: "Next Installment",
      sortable: true,
      width: "8rem",
    },
    {
      field: "next_installment_dt",
      header: "Next Installment Date",
      sortable: true,
      width: "8rem",
      customBody: (row) => (
        <Box>{row.next_installment_dt?.split("T")[0]}</Box>
      ),
    },
    {
      field: "installment_given",
      header: "Installment Given",
      sortable: true,
      width: "8rem",
    },
    {
      field: "action",
      header: "Action",
      sortable: true,
      width: "8rem",
      frozen: isDesktop ? true : false,
      alignFrozen: "right",
      customBody: (row) => (
         <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => editViewPayment(row)}
            className="commonBtnOne"
            startIcon={<EditOutlinedIcon />}
          >
            Edit
          </Button>
          <Button
            size="small"
            variant="contained"
            color="error"
            onClick={() => deleteViewPayment(row)}
            className="commonBtnOne"
            startIcon={<DeleteOutlinedIcon />}
          >
            Delete
          </Button>
        </Box>
      ),
    },
  ];

  return {
    columns,
    userData,
    data,
    isLoading,
    isError,
    fundDetail,
    HandlePagination,
    limitValue,
    editState,
    setEditState,
    editRowData,
    fundsFormFields,
    handleOnSubmit,
  };
};

export default usePaymentHistory;
